<template>
  <div class="case">
    <banner  />
    <div class="case-product">
      <div class="case-product-content">
        <img :src="caseIdList.Img" alt />
        <p class="product-title">{{caseIdList.Title}}</p>
        <p class="product-time">{{caseIdList.CreateTime}}</p>
        <div class="product-content" v-if="caseIdList.ContentHtml" v-html="caseIdList.ContentHtml" style="font-size: 16px"></div>
        <div class="product-content" v-else style="font-size: 16px; text-align:justify;text-justify:distribute-all-lines;/*ie6-8*/;
  text-align-last:justify;/* ie9*/;-moz-text-align-last:justify;/*ff*/;-webkit-text-align-last:justify;/*chrome 20+*/">{{caseIdList.Content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      caseIdList: {},
      caseList:[],
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.caseList=this.$caseList;
      this.caseList.forEach(item=>{
       if(item.Id==this.pid){
         this.caseIdList=item;
         return ;
       }
      })

      // this.$http
      //   .get(`Cases/GetCasesById/${this.pid}`)
      //   .then(response => {
      //     //console.log(response);
      //     this.caseIdList = response.data;
      //     window.console.log(this.caseIdList);
      //   })
      //   .catch(function(error) {
      //     window.console.log(error);
      //   });
    }
  }
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    //border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        height: 430px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>
